module.exports = __webpack_public_path__ + "img/img2.fcca52d8.png";